import { render } from "./Historytable.vue?vue&type=template&id=52b2c929"
import script from "./Historytable.vue?vue&type=script&lang=js"
export * from "./Historytable.vue?vue&type=script&lang=js"

import "./Historytable.vue?vue&type=style&index=0&id=52b2c929&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__